var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_keyof.js
// module id = ./node_modules/core-js/library/modules/_keyof.js
// module chunks = 11056403903869698000